import {
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldMonedasComponent from '../../../sistema/monedas/components/SelectFieldMonedas';
import { saveEntMonedasAction } from '../EntMonedasAction';

const FormEntMonedas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entMonedasStore = Redux.useSelector((state) => state.entMonedas);

  const activo = entMonedasStore.activo;

  const initData = {
    tasa: '0.00',
    oficial: false,
    idMoneda: '',
    idCambio: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idMoneda: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    setData({
      tasa: activo.tasa,
      oficial: activo.oficial,
      idMoneda: activo.moneda?.id ?? '',
      idCambio: activo.cambio?.id ?? '',
      idEstatus: activo.estatus?.id ?? 1,
    });
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveEntMonedasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        entMonedasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <LoadingWidget isLoading={loadingSave} isActivo={activo} />

        <Grid item xs={12} md={7}>
          <SelectFieldMonedasComponent
            value={data.idMoneda}
            onChange={(value) =>
              _handleSetDataField(CONST.moneda.idName, value)
            }
            isAll={false}
            isEmpty
            required
            error={dataError.idMoneda}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <FormControlLabel
            control={
              <Switch
                checked={data.oficial}
                onChange={(event) => {
                  _handleSetDataField(CONST.oficial.name, event.target.checked);
                }}
              />
            }
            label="Moneda oficial"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'row',
          }}
        >
          <Typography
            variant="body1"
            color="initial"
            align="center"
            sx={{ mr: 2 }}
          >
            Convertir a otra moneda
          </Typography>
          <SelectFieldMonedasComponent
            value={data.idCambio}
            onChange={(value) =>
              _handleSetDataField(CONST.cambio.idName, value)
            }
            isAll={false}
            isEmpty
            error={dataError.idCambio}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.tasa.name}
            label={CONST.tasa.label}
            value={data.tasa}
            onChange={(e) =>
              _handleSetDataField(CONST.tasa.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntMonedas;
